import QuestionsModel from '../Apis/Questions'
import Controller from './Controller'

export default class QuestionsController extends Controller {
  constructor() {
    super(new QuestionsModel())
  }
  async CourseQuestions(course_id,params) {
     const response = await this.model.CourseQuestions(course_id,params)
    return response
  }
}
